

import React, { useEffect, useState } from "react";
import { Link, replace, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Header/boxLogoWhite.png";
import HomeWhite from "../assets/home.png";
import HomeBlack from "../assets/home-1.png";
import ProfileWhite from "../assets/profile.png";
import ProfileBlack from "../assets/profile-1.png";
import VideoWhiteImage from "../assets/video.png";
import VideoBlackImage from "../assets/video-1.png";
import AudioWhiteImage from "../assets/audio_white.png";
import AudioBlackImage from "../assets/audio_black.png";
import PsychologistWhiteImage from "../assets/Psychologist/psychologist_white.png";
import PsychologistBlackImage from "../assets/Psychologist/psychologist_black.png";

const PsychologistHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const checkUserData = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    setIsLoggedIn(!!userData);
  };

  useEffect(() => {
    checkUserData();
  }, []);


  return (
    <div className="header-container">
      <div className="logo-container" style={{width:'40%'}} onClick={()=>{navigate("/", { replace: true });}}>
        <img src={logo} alt="logo" className="image-logo" />
        {/* <img src={HomeWhite} alt="logo" className="image-logo-home"/> */}
      </div>

      <div className="all-tabs" style={{justifyContent:'flex-start',width:'60%'}}>
       
          <div className="tab-container" onClick={()=>{navigate('/audioroom', { replace: true })}}>
            <img
              src={currentPath === "/audioroom" ? AudioBlackImage : AudioWhiteImage}
              alt="Psychologist"
              className="tab-image"
            />
            <h4 className="header-tab-name">Audio Session</h4>
          </div>
          <div className="tab-container" onClick={()=>{navigate('/videoroom', { replace: true })}}>
            <img
              src={currentPath === "/videoroom" ? VideoBlackImage : VideoWhiteImage}
              alt="Psychologist"
              className="tab-image"
            />
            <h4 className="header-tab-name">Video Session</h4>
          </div>
          <div className="tab-container" onClick={()=>{navigate('/homevisit', { replace: true })}}>
            <img
              src={currentPath === "/homevisit" ? HomeBlack : HomeWhite}
              alt="Psychologist"
              className="tab-image"
            />
            <h4 className="header-tab-name">HomeVisit</h4>
          </div>
        
        
        {/* {isLoggedIn ? (
          <div className="header-button-logout" onClick={handleLogout}>
            <img src={logoutImage} className="profile-logout-image" />
            <h3 className="header-button-logout-text">Logout</h3>
          </div>
        ) : (
          <button className="header-button" onClick={handleLoginClick}>
            <h4 className="header-button-text">SignUp</h4>
          </button>
        )} */}
      </div>
    </div>
  );
};

export default PsychologistHeader;
